// extracted by mini-css-extract-plugin
module.exports = {"slide":"SlideGallery_slide__PCdLg","thumbs":"SlideGallery_thumbs__ExGHw"};